import { Page } from './page/page';
import { User } from './user/user';
import { Product } from './product/product';
import { OmapiIdConstants } from '../../shared/omapi-id-constants';
import { Cart } from './cart/cart';
import { Event } from './event/event';
import { Price } from './price/price';
import { Item } from './item/item';
import { ProductInfo } from './product/productInfo';
import { Transaction } from './transaction/transaction';
import { Attribute } from './event/attribute';
var DigitalData = /** @class */ (function () {
    function DigitalData(pageName, language, user, product, cart, events, transaction) {
        this.appId = 'EOS TV Shop';
        this.brand = 'telenet';
        this.page = new Page(pageName, language);
        this.user = user;
        this.product = product;
        this.cart = cart;
        this.event = events;
        this.transaction = transaction;
    }
    DigitalData.createForHomePage = function (language, user, omapiIds) {
        return new DigitalData('tvshop/homepage', language, new User(user), this.mapToProducts(omapiIds), undefined, [], undefined);
    };
    DigitalData.createForDetailPage = function (language, user, omapiIds) {
        return new DigitalData(this.createDetailPageName(omapiIds[0]), language, new User(user), this.mapToProducts(omapiIds), undefined, [], undefined);
    };
    DigitalData.createForOptionsPage = function (language, user, omapiIds) {
        return new DigitalData(this.createDetailPageName(omapiIds[0]) + '/option', language, new User(user), this.mapToProducts(omapiIds), undefined, [], undefined);
    };
    DigitalData.createForOrderModal = function (currentLanguage, user, order) {
        return this.createDigitalDate(order, currentLanguage, user, new Event('add to cart', 'add', 'button', undefined));
    };
    DigitalData.createForPinEntered = function (currentLanguage, user, order) {
        return this.createDigitalDate(order, currentLanguage, user, new Event('order confirmation', 'pincode', 'form', undefined));
    };
    DigitalData.createForOrderSuccess = function (currentLanguage, user, order) {
        return new DigitalData(this.createDetailPageName(order.packOmapiId) + '/thankyou', currentLanguage, new User(user), undefined, undefined, [], DigitalData.mapToTransaction(order));
    };
    DigitalData.createForVoucherEntered = function (currentLanguage, user) {
        return new DigitalData('tvshop/voucher', currentLanguage, new User(user), undefined, undefined, [new Event('Voucher', 'voucher entry', 'form', undefined)], undefined);
    };
    DigitalData.createForVoucherResolved = function (currentLanguage, user, trialOmapiIds) {
        return new DigitalData('tvshop/voucher', currentLanguage, new User(user), undefined, undefined, this.createEventForTrials(trialOmapiIds, 'voucher entry'), undefined);
    };
    DigitalData.createVoucherCodeFailed = function (currentLanguage, user) {
        return new DigitalData('tvshop/voucher', currentLanguage, new User(user), undefined, undefined, [new Event('Voucher', 'voucher fail', 'form', undefined)], undefined);
    };
    DigitalData.createVoucherCodeSuccess = function (currentLanguage, user, trialOmapiId) {
        return new DigitalData('tvshop/voucher', currentLanguage, new User(user), undefined, undefined, this.createEventForTrials([trialOmapiId], 'voucher succes'), undefined);
    };
    DigitalData.createEventForTrials = function (trialOmapiIds, eventAction) {
        return trialOmapiIds.map(function (value) { return new Event('Voucher', eventAction, 'form', new Attribute(new ProductInfo(value, OmapiIdConstants.PRODUCT_NAME_MAP.get(value)))); });
    };
    DigitalData.createDigitalDate = function (order, currentLanguage, user, event) {
        return new DigitalData(this.createDetailPageName(order.packOmapiId), currentLanguage, new User(user), undefined, this.mapToCart(order), [event], undefined);
    };
    DigitalData.mapToProducts = function (omapiIds) {
        var products = [];
        omapiIds.forEach(function (omapiId, index) { return products[index] = new Product(omapiId, OmapiIdConstants.PRODUCT_NAME_MAP.get(omapiId)); });
        return products;
    };
    DigitalData.createDetailPageName = function (omapiId) {
        return 'tvshop/' + OmapiIdConstants.PRODUCT_NAME_MAP.get(omapiId).replace(/ /g, '').toLocaleLowerCase();
    };
    DigitalData.mapToCart = function (order) {
        return new Cart(new Price(order.totalPrice()), this.createCartItems(order));
    };
    DigitalData.createCartItems = function (order) {
        if (order.subPackOmapiId) {
            return [
                new Item(new ProductInfo(order.packOmapiId, OmapiIdConstants.PRODUCT_NAME_MAP.get(order.packOmapiId)), order.packOmapiIdPrice, 1),
                new Item(new ProductInfo(order.subPackOmapiId, OmapiIdConstants.PRODUCT_NAME_MAP.get(order.subPackOmapiId)), order.subPackOmapiIdPrice, 1)
            ];
        }
        return [
            new Item(new ProductInfo(order.packOmapiId, OmapiIdConstants.PRODUCT_NAME_MAP.get(order.packOmapiId)), order.packOmapiIdPrice, 1)
        ];
    };
    DigitalData.mapToTransaction = function (order) {
        return new Transaction(new Price(order.totalPrice()), this.createCartItems(order));
    };
    DigitalData.prototype.getPage = function () {
        return this.page;
    };
    DigitalData.prototype.getCart = function () {
        return this.cart;
    };
    DigitalData.prototype.getAppId = function () {
        return this.appId;
    };
    DigitalData.prototype.getBrand = function () {
        return this.brand;
    };
    DigitalData.prototype.getUser = function () {
        return this.user;
    };
    DigitalData.prototype.getProducts = function () {
        return this.product;
    };
    DigitalData.prototype.getEvents = function () {
        return this.event;
    };
    DigitalData.prototype.getTransaction = function () {
        return this.transaction;
    };
    DigitalData.prototype.getLastEvent = function () {
        var lastEvent;
        var events = this.getEvents();
        if (events !== undefined && events.length > 0) {
            lastEvent = events[events.length - 1];
        }
        return lastEvent;
    };
    DigitalData.prototype.getLastUser = function () {
        var lastUser;
        if (this.user !== undefined) {
            lastUser = this.user;
        }
        return lastUser;
    };
    return DigitalData;
}());
export { DigitalData };
